import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';

import { MenuItem, DropdownButton } from 'react-bootstrap';

import { GeneSelection } from '../GeneSelectButton';

import s from './GeneHeader.css';

const GeneHeader = ({ genes, limitSingleGene }) => {
  const xrefsMenu = (obj, idx) => (
    <MenuItem
      key={idx}
      href={obj.crossrefdb.url.replace('_REPL_', obj.xrid)}
      target="_blank"
    >
      {obj.crossrefdb.name}: {obj.xrid}
    </MenuItem>
  );

  let header = null;

  if (genes.length === 1) {
    const gene = genes[0];
    header = (
      <div className={s.root}>
        <ul className="list-inline text-center">
          <li>
            <div style={{ margin: 'auto' }}>
              <h1 className="text-center">{gene.standard_name}</h1>
            </div>
            <ul className={`${s.gene} list-inline`}>
              <li>
                <p className="text-center lead" style={{ marginBottom: '0px' }}>
                  {gene.description}
                </p>
              </li>
              <DropdownButton
                id="xrefs"
                bsStyle="link"
                className={s.button}
                title={<i className="fa fa-external-link" />}
              >
                {gene.xrefs.map(xrefsMenu)}
              </DropdownButton>
            </ul>
          </li>

          {limitSingleGene || (
            <li>
              <GeneSelection
                style={{ position: 'absolute', top: '75px' }}
                bsSize="xsmall"
                buttonText={<i className="fa fa-plus" />}
              />
            </li>
          )}
        </ul>
      </div>
    );
  } else if (genes.length < 9) {
    header = (
      <div className={s.multi} style={{ marginTop: '30px' }}>
        <ul className={`${s.gene} list-inline text-center`}>
          {genes.map(gene => (
            <li key={gene.standard_name} className={s.genecard}>
              <h3>{gene.standard_name}</h3>
              <p>
                <a
                  href={`http://www.ncbi.nlm.nih.gov/gene/${gene.entrez}`}
                  target="_blank noopener noreferrer"
                >
                  Entrez: {gene.entrez}
                </a>
              </p>
              <p>{gene.description}</p>
            </li>
          ))}
          <li>
            <GeneSelection
              style={{ marginTop: '50px' }}
              bsSize="xsmall"
              buttonText={<i className="fa fa-plus" />}
            />
          </li>
        </ul>
      </div>
    );
  } else {
    header = (
      <div>
        <div
          style={{
            position: 'relative',
            paddingLeft: '20px',
            paddingRight: '20px',
            float: 'right',
          }}
        >
          <GeneSelection
            style={{ marginTop: '50px' }}
            bsSize="xsmall"
            buttonText={<i className="fa fa-plus" />}
          />
        </div>
        <div className={s.multi} style={{ marginTop: '30px' }}>
          <ul className={`${s.gene} list-inline text-center`}>
            {genes.map(gene => (
              <li key={gene.standard_name} className={s.genecard}>
                <h3>{gene.standard_name}</h3>
                <p>
                  <a
                    href={`http://www.ncbi.nlm.nih.gov/gene/${gene.entrez}`}
                    target="_blank noopener noreferrer"
                  >
                    Entrez: {gene.entrez}
                  </a>
                </p>
                <p>{gene.description}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
  return header;
};

export default withStyles(s)(GeneHeader);
